<template>
  <div class="fixed top-0 left-0 right-0 z-50">
    <el-menu
      :default-active="active"
      class="el-menu-demo flex"
      mode="horizontal"
      background-color="#112f66"
      text-color="#fff"
      active-text-color="#e58d36"
      @select="handleSelect"
    >
      <div class="flex ml-6 items-center">
        <a
          class="flex items-center"
          href="https://www.cargosoon.com/"
          target="_blank"
        >
          <img
            src="@/assets/cargosoonLogo1.png"
            class="h-8 mr-1 hidden sm:block"
            alt=""
          />
          <img
            src="@/assets/cargosoonLogo2.png"
            class="h-6"
            alt=""
          />
        </a>

        <div class="mx-3">
          <el-input
            v-model="sinput"
            size="small"
            placeholder="Please input"
            prefix-icon="el-icon-search"
          />
        </div>
      </div>
      <el-menu-item index="/new/">Home</el-menu-item>

      <el-submenu index="2">
        <template #title>Quote</template>
        <el-menu-item index="/main/booking">DDP/DDU Freight</el-menu-item>
        <el-menu-item index="/main/FCL">Ocean Freight</el-menu-item>
        <el-menu-item index="/order/shippingOrder">Order</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template #title>Warehouse</template>
        <el-menu-item index="/warehouse/SKUManagement">Product</el-menu-item>
        <el-menu-item index="/warehouse/PreloadManagement">Box</el-menu-item>
        <el-menu-item index="/warehouse/Apply">Apply</el-menu-item>
        <el-menu-item index="/warehouse/InventoryStatistics">Inventory</el-menu-item>
        <el-menu-item index="/warehouse/CargoManagements">Transfer inventory</el-menu-item>
      </el-submenu>

      <el-submenu index="4">
        <template #title>DropShipping</template>
        <!-- <el-menu-item index="codropshipping">CoDropshipping</el-menu-item> -->
        <div
          class="meun-item"
          @click="goCodrop"
        >CoDropshipping</div>
        <el-menu-item index="/account/Shopify">Store</el-menu-item>
        <el-menu-item index="/account/storeOrder">Store Order</el-menu-item>
      </el-submenu>
      <el-menu-item index="/account/Bill">Biling</el-menu-item>

      <div class="flex items-center absolute right-10  h-full">
        <div
          v-if="istoken"
          class="flex"
        >
          <Notice></Notice>

          <el-submenu index="5">
            <template #title>
              <div class="p-1 flex items-center">
                <div class="relative">
                  <img
                    :src="headImg"
                    class="mr-1 sm:mr-4 w-10 h-10 rounded-full"
                    alt=""
                  />
                  <img
                    v-if="superLevel == 'L1'"
                    src="@/assets/lv1.png"
                    class="absolute right-0 -bottom-1.5 w-7"
                    alt=""
                  >
                  <img
                    v-if="superLevel == 'L2'"
                    src="@/assets/lv2.png"
                    class="absolute right-0 -bottom-1.5 w-7"
                    alt=""
                  >
                </div>
                <div class="max-w-200 overflow-hidden whitespace-nowrap overflow-ellipsis mr-5">{{userName}}</div>
              </div>
            </template>
            <el-menu-item index="/account/wallet">Wallet</el-menu-item>
            <!-- <el-menu-item index="/account/profile">Profile</el-menu-item>
            <el-menu-item index="/account/changePassword">Password</el-menu-item> -->
            <el-menu-item index="/accountnav">Account</el-menu-item>
            <el-menu-item index="/main/issus">Feedback</el-menu-item>
            <el-menu-item index="/login">Logout</el-menu-item>
          </el-submenu>
        </div>

        <div
          v-else
          class="mr-8"
        >
          <router-link :to="{ name: 'login' }">
            <button class="text-sm px-3 py-0.5 rounded bg-orange hover:bg-orange1 text-white">Log in</button>
          </router-link>
          <router-link :to="{ name: 'signUp' }">
            <button class="ml-3 text-sm px-3 py-0.5 rounded bg-orange hover:bg-orange1 text-white">Sign up</button>
          </router-link>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
import Notice from "./components/notice.vue";
export default {
  components: {
    Notice,
  },
  data() {
    return {
      active: "/new/home",
      istoken: false,
      sinput: "",
      superLevel: "",
      userName: "",
      headImg: "",
    };
  },
  created() {
    this.active = this.$route.path;

    if (this.$store.state.user.token) {
      this.istoken = true;
    } else {
      this.istoken = false;
    }
    if (this.istoken) {
      const userId = JSON.parse(localStorage.getItem("userId"));
      const headImg = JSON.parse(localStorage.getItem("userImg"));
      this.email = JSON.parse(localStorage.getItem("userInfo")).email;

      if (this.email == null) {
        this.headImg = require("../assets/moren.png");
      } else {
        this.headImg = headImg + userId + "_40_40.png";
      }
      let user = JSON.parse(localStorage.getItem("userInfo"));
      this.userName = user.first_name + " " + user.last_name;
      this.userID = user.id;
      this.superLevel = user.super_level;
      this.firstLogin = user.first_login;
    }
  },
  mounted() {},
  methods: {
    goCodrop() {
      window.open("https://codropshipping.com/", "_blank");
    },
    async logout() {
      try {
        await this.$store.dispatch("userLogout");
        localStorage.removeItem("loginto");
        this.$router.push("/login");
        window.localStorage.clear();
      } catch (error) {}
    },
    handleSelect(key, keyPath) {
      if (key == "/login") {
        this.logout();
        return;
      }
      window.location.href = key;
    },
  },
};
</script>

<style>
.meun-item {
  height: 36px;
  line-height: 36px;
  padding: 0 10px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.meun-item:hover {
  outline: 0;
  background-color: rgb(14, 38, 82);
}
</style>